import React from 'react';


export default class AdSense extends React.Component {
    componentDidMount () {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    render () {
        const mode = this.props.mode || 'v';

        if (mode === 'h'){
            return (
                <ins className='adsbygoogle'
                style={{ display: 'block' }}
                data-ad-format="fluid"
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-8907600991778888"
                data-ad-slot="5829208921"></ins>
            );

        } else {

            return (
                <ins className='adsbygoogle'
                style={{ display: 'block' }}
                data-ad-client="ca-pub-8907600991778888"
                data-ad-slot="4155543913"
                data-full-width-responsive="true"
                data-ad-format='auto' />
            );
        }
    }
}
